import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST,
  BRAND_DARK
} from "@streeteasy/design-system/colors";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import { H1, H6 } from "@streeteasy/design-system/typography";

import { largeScreen, smallScreen } from "src/shared/constants/screenSizes";

import { homeHero, homeHeroMobile } from "../../assets";

// The Large SVG aspect ratio is 1700x587 ≈ 2.896
// A 20:7 ratio between max-width and wrapper height seems to be the sweet spot
// for keeping the entire background image visible and undistorted
// 20:7 ≈ 2.857
export const HeroBlockWrapper = styled.div`
  background: no-repeat ${ACCENT_PRIMARY_LIGHTEST} url(${homeHero}) center
    bottom/3360px;
  background-size: 100% auto;
  height: calc(80vh - 148px);
  min-height: 550px;
  padding: 0 23px;

  @media screen and (max-width: ${largeScreen}px) {
    height: calc(80vh - 98px);
  }

  @media screen and (max-width: ${smallScreen}px) {
    height: ${props => (props.listingType === "for-rent" ? "686px" : "636px")};
    transition: 0.5s;
    background-image: url(${homeHeroMobile});
  }
`;

export const HeroTitle = styled(H1)`
  padding: 96px 0 50px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 40px 0 26px;
  }
`;

export const Link = styled(TextLink)`
  font-size: inherit;
`;

export const RegisterSignIn = styled(H6).attrs({
  as: "p"
})`
  padding: 10px;
  text-align: center;
`;

export const AuthLink = styled(TextLink)`
  color: ${BRAND_DARK};
  font-size: 16px;
`;
